<template>
  <div>
    <BaseList
      ref="productList"
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :titleAdd="$t('i18nCommon.AddProduct')"
      :isShowStatus="true"
      :isShowSupplier="true"
      :isShowCategory="true"
      @change="handleTableChange"
      @addData="addData"
      @loadDataFilter="loadDataFilter"
      @editRow="editRow"
      @deleteRow="deleteRow"
      @onDblclick="onDblclick"
      @updateColumns="(cols) => (columns = cols)"
    >
    </BaseList>
    <div v-if="isShow && product && Object.keys(product).length > 0">
      <a-modal v-model:open="isShow" centered :closable="false" :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Product") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form :size="formSize" status-icon label-position="left">
              <div class="flex">
                <div class="flex-1">
                  <div class="flex columns-1">
                    <a-form-item
                      prop="category"
                      testek="category"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Category") }}
                        </div>
                        <a-input
                          v-model:value="product.category.categoryName"
                          :disabled="true"
                        />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item
                      prop="supplier"
                      testek="supplier"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Supplier") }}
                        </div>
                        <a-input
                          v-model:value="product.supplier.supName"
                          :disabled="true"
                        />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item
                      prop="code"
                      testek="code"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Code") }}
                        </div>
                        <a-input
                          v-model:value="product.productCode"
                          :disabled="true"
                        />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item
                      prop="name"
                      testek="name"
                      class="w-full"
                      labelAlign="left"
                    >
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Name") }}
                        </div>
                        <a-input
                          v-model:value="product.productName"
                          :disabled="true"
                        />
                      </div>
                    </a-form-item>
                  </div>
                </div>
                <div class="flex flex-1 justify-center items-center">
                  <div class="logo-product-default h-64 w-64"></div>
                </div>
              </div>
              <div class="flex columns-1 mt-6">
                <a-form-item prop="unit" testek="unit" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Unit") }}
                    </div>
                    <a-input v-model:value="product.unit" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item
                  prop="description"
                  testek="description"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                    </div>
                    <a-input
                      v-model:value="product.productDesc"
                      class="w-full"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="price"
                  testek="price"
                  class="mr-8 w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Price") }}
                    </div>
                    <a-input
                      class="w-full"
                      v-model:value="product.price"
                      addon-after="VND"
                      :disabled="true"
                    ></a-input>
                  </div>
                </a-form-item>
                <a-form-item
                  prop="quantity"
                  testek="quantity"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Quantity") }}
                    </div>
                    <a-input
                      class="w-full"
                      v-model:value="product.quantity"
                      :disabled="true"
                    ></a-input>
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import dataFake from "@/data/dataFake";
import { mapActions, mapGetters } from "vuex";
import { ModuleCategory, ModuleProduct } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "ProductList",
  components: {
    BaseList,
  },
  data() {
    return {
      dataSource: dataFake.Products,
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      isShow: true,
      product: {},
    };
  },
  computed: {
    ...mapGetters(ModuleProduct, ["TotalInfo"]),
    paginationInfo() {
      return {
        total: this.TotalInfo.count,
        current: this.TotalInfo.page,
        pageSize: this.TotalInfo.limit,
      };
    },
  },
  async created() {
    const me = this;
    me.initDataStatic();
    await me.loadDataGrid();
    me.$emitter.on("LoadDataProduct", me.loadDataByKeyWord);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadDataProduct", me.loadDataByKeyWord);
  },
  methods: {
    ...mapActions(ModuleProduct, [
      "updateProduct",
      "deleteProduct",
      "getProducts",
      "getProduct",
    ]),
    ...mapActions(ModuleCategory, ["getCategories"]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),

    loadDataByKeyWord: _.debounce( async function(param) {
      const me = this;
      if (param) {
        if (me.$refs.productList) {
          me.$refs.productList.params.keyword = param.keyword;
        }
        let payload = {
          keyword: param.keyword,
          limit: me.pagination.pageSize,
          page: me.pagination.current,
        };
        await me.getProducts(payload);
      }
    },300),

    initDataStatic() {
      const me = this;
      me.columns = [
        {
          fixed: "left",
          title: me.$t("i18nProduct.Code"),
          dataIndex: "productCode",
          sorter: (a, b) =>
            me.$commonFunc.sortColumn(a.productCode, b.productCode),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nProduct.Name"),
          dataIndex: "productName",
          sorter: (a, b) =>
            me.$commonFunc.sortColumn(a.productName, b.productName),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nProduct.Description"),
          dataIndex: "productDesc",
          sorter: (a, b) =>
            me.$commonFunc.sortColumn(a.productDesc, b.productDesc),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nProduct.Quantity"),
          dataIndex: "quantity",
          sorter: (a, b) => a.quantity - b.quantity,
          width: 200,
          align: "right",
        },
        {
          title: me.$t("i18nProduct.Price"),
          dataIndex: "price",
          sorter: (a, b) => a.price > b.price,
          width: 200,
          align: "right",
        },
        {
          title: me.$t("i18nProduct.Unit"),
          dataIndex: "unit",
          sorter: (a, b) => a.unit - b.unit,
          width: 200,
        },
        {
          title: me.$t("i18nProduct.SupplierName"),
          keyIndex: "supplierObject",
          dataIndex: "supName",
          sorter: (a, b) =>
            a.supplier &&
            b.supplier &&
            me.$commonFunc.sortColumn(a.supplier.supName, b.supplier.supName),
          width: 200,
        },
        {
          title: me.$t("i18nProduct.CategoryName"),
          keyIndex: "categoryObject",
          dataIndex: "categoryName",
          sorter: (a, b) =>
            a.category &&
            b.category &&
            me.$commonFunc.sortColumn(
              a.category.categoryName,
              b.category.categoryName
            ),
          width: 200,
        },
        {
          title: me.$t("i18nProduct.Status"),
          dataIndex: "status",
          width: 150,
          align: "center",
        },
        {
          title: me.$t("i18nCommon.Action"),
          key: "rightWidgetDefault",
          fixed: "right",
          width: 150,
        },
      ];
    },

    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getProducts(payload);
    },

    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getProducts(payload);
    }, 300),

    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;
      me.$router.push("/create-product");

      setTimeout(() => {
        me.$emitter.emit("LoadEditProduct", {
          id: dataRow.id,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteProductFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteProductConfirm", {
          name: dataRow.productName,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteProduct({ id: dataRow.id });
          if (result && result.code == 200) {
            await me.loadDataGrid();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteProductSuccess")
            );
          } else if (
            result &&
            (result.statusCode == 400 || result.statusCode == 409)
          ) {
            me.$messageNotification.messageNotification(
              result.message,
              "warning"
            );
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteProductFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    addData() {
      const me = this;
      me.$router.push("/create-product");
    },
    async onDblclick(params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.product = await me.getProduct({ id: params.id });
      if (me.product) {
        me.isShow = true;
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
  background-color: initial !important;
}
</style>
